module.exports = __webpack_public_path__ + "img/2.07533418.jpg";